import { Switch } from 'react-router-dom'
import { CIMSPage, Permission } from '@cims-online/shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import IssueTypes from './IssueTypes'
import IssueTypesProvider from './IssueTypes/IssueTypesContext'
import DispositionTypes from './DispositionTypes'
import DispositionTypesProvider from './DispositionTypes/DispositionTypesContext'
import IssueQuickLinks from './IssueQuickLinks'
import IssueTracker from './IssueTracker'
import IssueNotifications from './IssueNotifications'

const Issues: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[
          CIMSPage.IssueTracker.recordPath,
          CIMSPage.IssueTracker.projectPath,
        ]}
        permissions={Permission.ViewIssue}
      >
        <IssueTracker />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.IssueTypes.projectPath}
        permissions={Permission.ViewIssueType}
      >
        <IssueTypesProvider>
          <IssueTypes />
        </IssueTypesProvider>
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.IssueDispositionTypes.projectPath}
        permissions={Permission.ViewIssueDispositionType}
      >
        <DispositionTypesProvider>
          <DispositionTypes />
        </DispositionTypesProvider>
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.IssueQuickLinks.projectPath}
        permissions={Permission.ViewIssueQuickLink}
      >
        <IssueQuickLinks />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.IssueNotifications.projectPath}
        permissions={Permission.ViewIssueNotification}
      >
        <IssueNotifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default Issues
